function initVariantButtons() {

  document.querySelectorAll(".variant-buttons").forEach(function(wrapper) {

    if (wrapper.dataset.initialized === "true") return;

    wrapper.dataset.initialized = "true";

    if (!wrapper.dataset.product) return;

    let productData;

    try {
      productData = JSON.parse(wrapper.dataset.product);
    } catch (e) {
      console.error(e);
      return;
    }

    const gstRate = parseFloat(wrapper.dataset.gstRate || 0);

    const buttons = wrapper.querySelectorAll(".variant-btn");

    const card = wrapper.closest(".card");

    if (!card) return;

    const image = card.querySelector(".primary-image");
    const priceWrapper = card.querySelector(".price-wrapper");
    const variantInput = card.querySelector(".variant-id-input");

    function updateVariant(selectedVariant, btn = null) {

      if (!selectedVariant) return;

      // active class
      if (btn) {
        buttons.forEach(b => b.classList.remove("active"));
        btn.classList.add("active");
      }

      // IMAGE
      if (image) {

        let variantImage = null;

        if (selectedVariant.featured_image) {
          variantImage =
            selectedVariant.featured_image.src ||
            selectedVariant.featured_image.url;
        }

        if (variantImage) {

          variantImage = variantImage.split('?')[0];

          image.src = variantImage + '?width=533';
        }
      }

      // PRICE
      if (priceWrapper) {

        let basePrice = selectedVariant.price / 100;

        let finalPrice = basePrice + (basePrice * gstRate);

        let decimalPart = finalPrice - Math.floor(finalPrice);

        if (decimalPart <= 0.25) {
          finalPrice = Math.floor(finalPrice);
        } else {
          finalPrice = Math.ceil(finalPrice);
        }

        priceWrapper.innerHTML =
          "₹" + finalPrice +
          ' <span class="including-gst">(Including GST)</span>';
      }

      // VARIANT INPUT
      if (variantInput) {
        variantInput.value = selectedVariant.id;
      }
    }

    // CLICK
    buttons.forEach(function(btn) {

      btn.addEventListener("click", function() {

        const variantId = btn.dataset.id;

        const selectedVariant = productData.variants.find(
          v => String(v.id) === String(variantId)
        );

        updateVariant(selectedVariant, btn);
      });

    });

    // DEFAULT
    let firstBtn =
      wrapper.querySelector(".variant-btn.active") || buttons[0];

    if (firstBtn) {

      const variantId = firstBtn.dataset.id;

      const selectedVariant = productData.variants.find(
        v => String(v.id) === String(variantId)
      );

      updateVariant(selectedVariant, firstBtn);
    }

  });

}

document.addEventListener("DOMContentLoaded", function() {

  initVariantButtons();

});

// related products ajax
document.addEventListener("shopify:section:load", function() {

  initVariantButtons();

});

// observe ajax loaded products
const observer = new MutationObserver(function() {

  initVariantButtons();

});

observer.observe(document.body, {
  childList: true,
  subtree: true
});